import { c as _c } from "react/compiler-runtime";
import { SearchInput, SelectInput } from '@/components/inputs';
import { addPrefixToDataParams } from '@/utils/string';
import React from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { PartnerCategory } from '@/types/partners';
import { SELECT_ALL_VALUE } from '@/hooks/searchParamParsers';
import { FIELD_CATEGORY, FIELD_FULLTEXT, FIELD_PAYMENT_METHOD, PAYMENT_METHOD_ALL, PAYMENT_METHOD_DEFERRED_PAYMENT, PAYMENT_METHOD_PAY_IN_THREE, PaymentMethodFieldValues, SearchFormValues } from '@/hooks/useWhereToShop';
import { FormApi } from 'final-form';
import { logEvent } from '@/analytics/events';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { Text } from '@/components/typography';
import { formatNum } from '@/utils/formatting';
import { Language } from '@/constants/currencyConfig';
import { CheckboxButton } from '@/components/buttons';
function getUpdatedPaymentMethod(currentValue: string | undefined, method: PaymentMethodFieldValues): PaymentMethodFieldValues | undefined {
  if (currentValue === PAYMENT_METHOD_ALL) {
    return method === PAYMENT_METHOD_DEFERRED_PAYMENT ? PAYMENT_METHOD_PAY_IN_THREE : PAYMENT_METHOD_DEFERRED_PAYMENT;
  }
  if (currentValue === method) {
    return undefined;
  }
  if (currentValue === PAYMENT_METHOD_PAY_IN_THREE && method === PAYMENT_METHOD_DEFERRED_PAYMENT || currentValue === PAYMENT_METHOD_DEFERRED_PAYMENT && method === PAYMENT_METHOD_PAY_IN_THREE) {
    return PAYMENT_METHOD_ALL;
  }
  return method;
}
function Search(t0) {
  const $ = _c(20);
  const {
    partnersCategories,
    initialValues,
    handleSearch,
    searchForm,
    totalCount
  } = t0;
  const {
    t,
    i18n
  } = useTranslation("whereToShop");
  let t1;
  if ($[0] !== t) {
    t1 = t("form.allCategoriesOption");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      label: t1,
      value: SELECT_ALL_VALUE
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const allCategoriesOption = t2;
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t3;
  if ($[4] !== allCategoriesOption || $[5] !== partnersCategories) {
    t3 = partnersCategories && partnersCategories?.length > 0 ? [allCategoriesOption, ...partnersCategories.map(_temp)] : [allCategoriesOption];
    $[4] = allCategoriesOption;
    $[5] = partnersCategories;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const categoryOptions = t3;
  const logSearchEvent = _temp2;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value_0 => {
      logSearchEvent("search_by_eshop", value_0);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const logSearchFulltextEvent = t4;
  let t5;
  if ($[8] !== categoryOptions || $[9] !== handleSearch || $[10] !== i18n || $[11] !== initialValues || $[12] !== isCsLanguage || $[13] !== partnersCategories || $[14] !== t || $[15] !== totalCount) {
    t5 = t6 => {
      const {
        form,
        handleSubmit
      } = t6;
      return <><FormSpy subscription={{
          values: true
        }} onChange={t7 => {
          const {
            values
          } = t7;
          return handleSearch(values);
        }} /><form onSubmit={handleSubmit} {...addPrefixToDataParams({
          analyticsParam: "whereToShopSearch",
          testId: "whereToShopSearch",
          prefix: "form"
        })}><div className="flex w-full flex-col gap-2 md:flex-row md:gap-4"><Field name={FIELD_FULLTEXT} initialValue={initialValues?.[FIELD_FULLTEXT]} className="w-full">{fieldRenderProps => <SearchInput {...fieldRenderProps} label={t("form.searchLabel")} hideLabel={true} onClean={() => {
                form.change(FIELD_FULLTEXT, undefined);
                logSearchFulltextEvent(SELECT_ALL_VALUE);
              }} onChange={value_1 => {
                logSearchFulltextEvent(value_1);
              }} />}</Field><Field name={FIELD_CATEGORY} initialValue={initialValues?.[FIELD_CATEGORY]} className="w-full md:w-80 md:shrink-0">{fieldRenderProps_0 => <SelectInput {...fieldRenderProps_0} label={t("form.categoryLabel")} hideLabel={true} options={categoryOptions} onSelect={value_2 => {
                const category_0 = partnersCategories?.find(c => c.id === value_2);
                logSearchEvent("search_by_category", category_0?.name || value_2);
              }} />}</Field></div><div className="flex flex-col justify-between gap-6 md:flex-row md:items-center md:gap-4"><Field name={FIELD_PAYMENT_METHOD} initialValue={initialValues?.[FIELD_PAYMENT_METHOD]}>{t8 => {
                const {
                  input
                } = t8;
                const handleCheckboxToggle = method => {
                  const currentValue = input.value;
                  const updatedMethod = getUpdatedPaymentMethod(currentValue, method);
                  input.onChange(updatedMethod);
                  bb73: switch (updatedMethod) {
                    case PAYMENT_METHOD_PAY_IN_THREE:
                      {
                        logSearchEvent("search_by_method", t("form.isPayInThreeOption"));
                        break bb73;
                      }
                    case PAYMENT_METHOD_DEFERRED_PAYMENT:
                      {
                        logSearchEvent("search_by_method", t("form.isDefermentPaymentOption"));
                        break bb73;
                      }
                    default:
                      {
                        logSearchEvent("search_by_method", "All");
                      }
                  }
                };
                const isChecked = method_0 => {
                  const currentValue_0 = input.value;
                  if (currentValue_0 === PAYMENT_METHOD_ALL) {
                    return true;
                  }
                  return currentValue_0 === method_0;
                };
                return <div className="-mx-4 mt-4 flex gap-2 overflow-x-auto px-4"><CheckboxButton label={t("form.isPayInThreeOption")} isChecked={isChecked(PAYMENT_METHOD_PAY_IN_THREE)} onChange={() => handleCheckboxToggle(PAYMENT_METHOD_PAY_IN_THREE)} />{isCsLanguage && <CheckboxButton label={t("form.isDefermentPaymentOption")} isChecked={isChecked(PAYMENT_METHOD_DEFERRED_PAYMENT)} onChange={() => handleCheckboxToggle(PAYMENT_METHOD_DEFERRED_PAYMENT)} />}</div>;
              }}</Field>{!!totalCount && totalCount > 0 && <Text as="p" variant="p3" className="text-light-gray-500 text-right md:shrink-0">{formatNum(totalCount, {}, i18n.language as Language)} {t(totalCount > 4 ? "storeCount_many" : totalCount > 1 ? "storeCount_few" : "storeCount")}</Text>}</div></form></>;
    };
    $[8] = categoryOptions;
    $[9] = handleSearch;
    $[10] = i18n;
    $[11] = initialValues;
    $[12] = isCsLanguage;
    $[13] = partnersCategories;
    $[14] = t;
    $[15] = totalCount;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== searchForm || $[18] !== t5) {
    t6 = <Form form={searchForm} onSubmit={searchForm.submit}>{t5}</Form>;
    $[17] = searchForm;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp2(action, value) {
  if (value) {
    logEvent("search", {
      action,
      ...(action === "search_by_eshop" && {
        search_term: value
      }),
      ...(action === "search_by_category" && {
        search_service: value
      }),
      ...(action === "search_by_method" && {
        search_method: value
      })
    });
  }
}
function _temp(category) {
  return {
    label: category.name,
    value: category.id
  };
}
export default Search;